import React from 'react';
import NavBar from '../NavBar/index';
import ClientsCarousel from '../ClientsCarousel/index';
import Presentation1 from '../Presentation/presentation1';
import Presentation2 from '../Presentation/presentation2';
import ContactForm from '../ContactForm/index';
import NewsCarousel from '../NewsCarousel';

import logo from '../../assets/logos/logo1.png';


import './LandingPage.css';

const LandingPage = () => {
    console.log('Landing')

  return (
    <div>
      <NavBar />
      <div className="image-container">
        <img src={logo} alt={"poplavsky-logo"}></img>
        <h2 className='text-container'>Poplavsky Group es un conjunto de Compañías con sedes en Argentina, Estados Unidos, 
          Reino Unido y Emiratos Árabes Unidos. Nuestra misión es poder brindar a nuestros clientes el mejor servicio posible 
          de la más alta calidad profesional, en materia legal, comercial, tax compliance y otros.</h2>
      </div>
      <main>
        <section>
          <ClientsCarousel />
        </section>
        <section>
          <Presentation1 />
          <Presentation2 />
        </section>
        <section>
          <div className="founders-container">
            <h2 className="title">MEDIOS</h2>
          </div>
          <NewsCarousel />
        </section>
        <section>
          <ContactForm />
        </section>
      </main>
    </div>
  );
};

export default LandingPage;
